import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d590a302"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 다음 > ")

import { computed } from 'vue';
  import { useRoute } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();

  const tabIndex = computed(() => {
    return Number(route.query.tab) || 0;
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "next-button",
    to: { query: { ..._unref(route).query, tab: _unref(tabIndex) + 1 } },
    replace: ""
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})